import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './result-card.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';

class ResultCardBlock extends s {
    constructor() {
        super(...arguments);
        this.blockId = '';
        this.items = [];
    }
    get isRTL() {
        return this.rtl || isRTL();
    }
    renderCTA(item) {
        var _a;
        return $ `<generic-button-updated label="${item.ctaLabel}" href="${item.ctaUrl}" target="${(_a = item.ctaTarget) !== null && _a !== void 0 ? _a : '_self'}" type="primary" color="burgundy" styleType="light"></generic-button-updated>`;
    }
    renderMedia(item) {
        var _a, _b, _c;
        if (item.mediaType === 'image') {
            return $ `<generic-image src="${(_a = item.imageUrl) !== null && _a !== void 0 ? _a : ''}" alt="${(_b = item.imageAlt) !== null && _b !== void 0 ? _b : ''}" loading="lazy"></generic-image>`;
        }
        return $ `<span class="result-card__emoji" role="img" aria-label="${(_c = item.emojiLabel) !== null && _c !== void 0 ? _c : ''}">${item.emoji}</span>`;
    }
    resolveItem() {
        var _a, _b, _c, _d;
        const params = new URLSearchParams(window.location.search);
        const outcome = (_b = (_a = this.outcome) !== null && _a !== void 0 ? _a : params.get('outcome')) !== null && _b !== void 0 ? _b : '';
        return ((_d = (_c = this.items.find(i => i.outcomeKey === outcome)) !== null && _c !== void 0 ? _c : this.items.find(i => i.outcomeKey === '' || i.outcomeKey === '*')) !== null && _d !== void 0 ? _d : null);
    }
    stripHtml(text) {
        var _a, _b;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return (_b = (_a = doc.body.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    }
    render() {
        const item = this.resolveItem();
        if (!item) {
            return $ `<div role="region" aria-label="Result" class="result-card result-card--empty"></div>`;
        }
        return $ `<section class="result-card" dir="${this.isRTL ? 'rtl' : 'ltr'}" aria-label="${this.stripHtml(item.text)}" id="${this.blockId}"><div class="result-card__media">${this.renderMedia(item)}</div><div class="result-card__content"><div class="result-card__text">${o(item.text)}</div>${this.renderCTA(item)}</div></section>`;
    }
}
ResultCardBlock.styles = css_248z;
__decorate([
    e({ type: Boolean })
], ResultCardBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], ResultCardBlock.prototype, "blockId", void 0);
__decorate([
    e({ type: Array })
], ResultCardBlock.prototype, "items", void 0);
__decorate([
    e({ type: String })
], ResultCardBlock.prototype, "outcome", void 0);
customElements.define('result-card', ResultCardBlock);

export { ResultCardBlock };
